import { useAangifte } from "components/aangifte/AangifteProvider";
import React, { FunctionComponent, useEffect, useState } from "react";

export interface Props {}

export const PostcodeField: FunctionComponent<Props> = () => {
  const {
    dispatch,
    aangifte: { city },
  } = useAangifte();
  const [postcode, setPostcode] = useState(city?.postalcode || "");

  const handleChange = ({ target: { value } }: React.ChangeEvent<HTMLInputElement>) => {
    setPostcode(value);
    dispatch({ type: "UPDATE_POSTALCODE", postalcode: value });
  };

  useEffect(() => {
    setPostcode(() => city?.postalcode || "");
  }, [city?.postalcode]);

  return <input
      type="text" id="postalcode" name="postalcode"
      className={`${city?.postalcode !== undefined ? "" : "postcodeError"}`}
      maxLength={4} value={postcode} onChange={handleChange} />;
};

PostcodeField.displayName = "PostcodeField";
